module.exports = __webpack_public_path__ + "00352e810b1a89502153adf4345848e7.png";